<template>
  <div name="CxServices" class="CxServices" id="services">
    <h2>Servicios</h2>
    <div class="cards">
      <div v-for="(card, index) in cards" :key="index" class="card">
        <img :src="card.image" :alt="card.title" loading="lazy"/>
        <h3>{{ card.title }}</h3>
        <p v-html="card.description"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CxServices",
  props: {
    msg: String,
  },
  data() {
    return {
      cards: [
        {
          image: require("@/assets/icon/data exploration.svg"),
          title: "Impulse sus decisiones con datos optimizados",
          description:
            "Libere el potencial de sus datos con nuestro servicio de optimización. A través de técnicas y análisis avanzados de <strong>ciencia de datos</strong>, transformamos sus datos en información valiosa y confiable. Mejoramos la calidad, integridad y eficiencia de sus datos, proporcionándole una base sólida para tomar decisiones estratégicas con confianza.",
        },
        {
          image: require("@/assets/icon/laptop.svg"),
          title: "Crear una presencia en línea impresionante y personalizada",
          description:
            "Lleve su negocio al siguiente nivel con nuestro servicio de <strong>desarrollo web</strong> personalizado. Diseñamos y construimos sitios web profesionales y cautivadores que se adaptan a sus necesidades específicas. Desde la navegación intuitiva hasta las funciones personalizadas, creamos una experiencia de usuario excepcional que impulsará los resultados de su negocio.",
        },
        {
          image: require("@/assets/icon/currency exchange.svg"),
          title: "Haz que tu marca brille en el mundo digital",
          description:
            "El <strong>diseño digital</strong> importa. Nuestro impresionante servicio de diseño digital le ayuda a destacar en el mundo digital. Desde el diseño de logotipos y materiales promocionales hasta la creación de interfaces de usuario cautivadoras, creamos una imagen visualmente atractiva y cohesiva que se alinea con su marca. Deje una impresión duradera en sus clientes y transmita su mensaje de manera convincente.",
        },
        {
          image: require("@/assets/icon/world.svg"),
          title: "Conquista el mundo digital con estrategia",
          description:
            "El <strong>marketing digital</strong> estratégico es clave para el crecimiento de su negocio en línea. Nuestro equipo de expertos desarrolla estrategias personalizadas que mejoran la visibilidad, generan clientes potenciales y convierten prospectos en ventas. Con técnicas de SEO, gestión de redes sociales y análisis de datos, dirigimos el tráfico a su sitio web, asegurando un impacto duradero en su audiencia.",
        },
        {
          image: require("@/assets/icon/cloud done.svg"),
          title: "Lidera la transformación digital de tu negocio",
          description:
            "Adopte la transformación digital con nuestra consultoría especializada en innovación tecnológica. Brindamos orientación sobre la implementación de soluciones tecnológicas disruptivas como <strong>inteligencia artificial, IoT y blockchain</strong>. Mejore la eficiencia de sus operaciones, impulse la competitividad y manténgase a la vanguardia en un mundo digital en constante evolución.",
        },
        {
          image: require("@/assets/icon/store.svg"),
          title: "Maximice su presencia en línea con información procesable",
          description:
            "Libere el poder de su presencia en línea a través del <strong>análisis web y la optimización de conversiones</strong>. Utilizamos herramientas de datos y análisis para comprender el comportamiento del usuario, mejorar su experiencia y maximizar sus conversiones. Con pruebas A / B y estrategias basadas en datos, logramos un crecimiento sostenible para su negocio en línea.",
        },
      ],
    };
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Homenaje&family=Source+Sans+3:wght@200&display=swap");

.CxServices {
  padding: 5px 20px 80px;
  width: 80vw;
  max-width: 1200px;
  margin: auto;
}

h2 {
  color: var(--color-accent);
  font-family: var(--font-sans);
  font-size: 4rem;
  font-weight: bold;
  margin: 30px auto;
}

.cards {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 20px;
}

strong {
  color: var(--color-primary);
}

@media (min-width: 768px) {
  .cards {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1024px) {
  .cards {
    grid-template-columns: repeat(3, 1fr);
  }
}

.card {
  border-radius: 10px;
  border: 3px solid var(--color-accent);
  color: var(--color-accent);
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.card:hover {
  color: var(--color-primary);
  border: 3px solid var(--color-primary);
  transform: scale(1.1);
}

.card>img {
  margin: auto;
}

.card>h3 {
  font-family: var(--font-homenaje);
  margin: 5px 0;
}

.card>p {
  font-family: var(--font-sans);
}
</style>
